export enum CART_ACTIONS_TYPES {
  SET_CART_ITEMS = `CART/SET_CART_ITEMS`,
  ADD_ITEM_TO_CART = `CART/ADD_ITEM_TO_CART`,
  UPDATE_ITEM_OF_THE_CART = `CART/UPDATE_ITEM_OF_THE_CART`,
  CLEAR_ALL_ITEMS_OF_THE_CART = `CART/CLEAR_ALL_ITEMS_OF_THE_CART`
}
